import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
export default {
    findcoa(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`coa/findcoa/${obj.kodeacc}/${obj.tahun}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    headcategory(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/itemcategory/headcategory`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'kode', 'nama', 'Account'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/itemcategory${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listhead(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/itemcategory/listhead`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("itemcategory", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`/itemcategory/${encodeURIComponent(obj.kode)}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
};